import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { getFirstItem } from 'lib/util'
import Icon from 'ui/Element/Icon'
import Badge from 'ui/Element/Badge'

const styles = () => ({
  icon: {
    width: '2.5rem',
    minHeight: '2.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/**
 * Displays the icon of a request.
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    props for the component
 * @returns {JSX.Element}
 */
const ListItemCellDashboardRequestIcon = (classes, props = {}) => {
  const { unreadMessages, events, type: typeKey, status } = props

  const [type] = events?.getTicketType?.(typeKey) || []
  const typeIcon = type?.icon
  const { color = 'black.main', backgroundColor = 'background.mobile' } = getFirstItem(events?.getRequestStatus?.(status)) || {}

  return (
    <Grid
      item
      xs={'auto'}
      className={classes.icon}
    >
      <Badge
        dot={true}
        value={unreadMessages}
        iconColor={backgroundColor}
      >
        <Icon
          size={32}
          color={color}
          shape={'circle'}
          source={typeIcon}
          padding={'0.5rem'}
          background={backgroundColor}
        />
      </Badge>
    </Grid>
  )
}

export default CellHOC(ListItemCellDashboardRequestIcon, styles)
